import { IconFlag } from "@tabler/icons-react"
import { Badge } from "design-system/atoms/Badge"
import { useCountries } from "modules/shared/hooks/useCountries"
import { useTranslation } from "react-i18next"

type Props = {
  country?: string | null
}

export const CustomerTargeting = ({ country }: Props) => {
  const { t } = useTranslation()
  const { labels: countryLabels } = useCountries()

  return (
    <div className="flex flex-row flex-wrap items-center gap-2">
      {country ? (
        <Badge variant="outline">
          <IconFlag size={14} />
          {countryLabels[country] ?? country}
        </Badge>
      ) : (
        <Badge variant="outline">{t("conversations.chat.customer.noTargeting")}</Badge>
      )}
    </div>
  )
}
